// src/api/paymentTransactionAPI.js
import apiClient from './client';

const PAYMENT_TRANSACTIONS_URL = '/api/v1/payment_transactions/';

// Get all payment transactions with optional filters
export const getPaymentTransactions = async (params = {}) => {
  try {
    const response = await apiClient.get(PAYMENT_TRANSACTIONS_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching payment transactions:', error);
    throw error;
  }
};

// Get a single payment transaction by ID
export const getPaymentTransaction = async (transactionId) => {
  try {
    const response = await apiClient.get(`${PAYMENT_TRANSACTIONS_URL}${transactionId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching payment transaction ${transactionId}:`, error);
    throw error;
  }
};

// Get payment transaction by Stripe intent ID
export const getPaymentTransactionByStripeIntent = async (stripeIntentId) => {
  try {
    const response = await apiClient.get(`${PAYMENT_TRANSACTIONS_URL}stripe/${stripeIntentId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching payment transaction by Stripe intent ${stripeIntentId}:`, error);
    throw error;
  }
};

// Create a new payment transaction
export const createPaymentTransaction = async (transactionData) => {
  try {
    const response = await apiClient.post(PAYMENT_TRANSACTIONS_URL, transactionData);
    return response.data;
  } catch (error) {
    console.error('Error creating payment transaction:', error);
    throw error;
  }
};

// Update a payment transaction
export const updatePaymentTransaction = async (transactionId, transactionData) => {
  try {
    const response = await apiClient.put(`${PAYMENT_TRANSACTIONS_URL}${transactionId}`, transactionData);
    return response.data;
  } catch (error) {
    console.error(`Error updating payment transaction ${transactionId}:`, error);
    throw error;
  }
};